// #region imports

// --- Angular
import { Component, Input } from '@angular/core';

// #endregion

@Component({
  selector: 'hs-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss']
})
export class AvatarComponent {
  @Input() image: string = '';
  @Input() text: string = '';
  @Input() rounded: boolean = true;
}
